<mat-chip-listbox *ngIf="items?.length">
  <mat-chip-option *ngFor="let item of items"
            [removable]="true"
            (removed)="onItemRemove(item)">
    {{displayMethod ? displayMethod(item) : item[displayKey]}}
    <mat-icon matChipRemove>cancel</mat-icon>
  </mat-chip-option>
</mat-chip-listbox>
